export enum PeriodicidadeEnum {
	Mensal = 1,
	Diario = 2,
	Bimestral = 3,
	Trimestral = 4,
	Quadrimestral = 5,
	Semestral = 6,
	Anual = 7,
	Semanal = 8,
	Unica = 9
}
